import { createTheme } from '@mui/material/styles';

import OpenSans from '../assets/fonts/OpenSans-Regular.woff2'

const theme = createTheme({
  palette: {
    primary: {
      main: '#42555E',
      light: '#F2F3F4',
      red: '#BE161D'
    }
  },
  typography: {
    fontFamily: 'OpenSans',
    fontSize: 14,
    h1: {
      fontSize: 26,
      marginTop: 10,
      marginBottom: 10
    },
    regular: {
      fontSize: 14,
      display: 'block'
    },
    small: {
      fontSize: 12,
      display: 'block'
    },
    quoteDetails: {
      fontSize: 12,
      margin: 5
    },
    dataTableHeader: {
      color: '#FFFFFF',
      fontWeight: 600
    },
    tableRow: {
      color: '#151515'
    }
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: `
        @font-face {
          font-family: 'OpenSans';
          font-style: normal;
          font-display: swap;
          font-weight: 300;
          src: local('OpenSans'), local('OpenSans-Regular'), url(${OpenSans}) format('woff2');
          unicodeRange: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF;
        }
      `,
    },
    MuiTabs: {
      styleOverrides: {
         indicator: {
          display: "none"
        }
      }
    },
    MuiTab: {
      styleOverrides: {
        root: {
          fontWeight: 300,
          color: '#151515',
          '&.Mui-selected': {
            color: '#151515',
            fontWeight: 600,
            backgroundColor: '#FFFFFF',
            border: "1px solid #EEEEEE",
            borderRadius: '5px 5px 0 0',
            "&:hover": {
              backgroundColor: '#FFFFFF',
            }
          },
          "&:hover": {
            backgroundColor: '#BDC2C7',
            borderRadius: '5px 5px 0 0',
          }
        }
      }
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          height: '35px',
          '&.Mui-disabled': {
            backgroundColor: '#F2F3F4'
          }
        }
      }
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          fontSize: '14px'
        }
      }
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          padding: 7
        }
      }
    }
  }
});

export default theme;